define(function() {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/attachment_model');
	const attachment_utilities = require('civicsUtils/attachment_utility');

	return IpsModelCollection.extend({
		model: theModel,
		//urlRoot: 'delegate/civics-api/api/cdr/common/fees',
		parse: function(response) {
			//this.responseStatus = response.responseStatus;
			if(response.data){
				attachment_utilities.parseVirusScanStatus(response.data);
			}
		    return response;//.data;
		},
	});
});
